import React from 'react';
import styles from './direction-button.module.scss';

const DirectionButton = ({ children, link, color }) => {
  return (
    <span className={styles.button}>
      {children}
    </span>
  );
};

export default DirectionButton;



// WEBPACK FOOTER //
// ./src/components/direction-button-row/direction-button.js